import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pt-2" }
const _hoisted_2 = { class: "mx-2 my-2" }
const _hoisted_3 = {
  key: 0,
  class: "p-3 m-3 bg-white text-size-14 text-center"
}
const _hoisted_4 = { ref: "bottomRef" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_FavListNav = _resolveComponent("FavListNav")!
  const _component_OrderCardSimple = _resolveComponent("OrderCardSimple")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createTextVNode("\n      お気に入り\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_FavListNav),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderListAggregateDate, ({ date, orderList }) => {
        return (_openBlock(), _createElementBlock("div", { key: date }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.formatDate(date)), 1),
          _createTextVNode(),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderList, (order) => {
            return (_openBlock(), _createBlock(_component_OrderCardSimple, {
              key: order.id,
              order: order,
              isLogin: _ctx.isLogin,
              isRegisteredWatchLater: _ctx.isRegisteredWatchLater(order),
              isShowAdditionalLabel: true,
              evaluation: _ctx.getEvaluation(order),
              onCardClick: ($event: any) => (_ctx.onCardClick(order)),
              onChangeWatchLater: ($event: any) => (_ctx.onWatchLaterChange(order)),
              class: "my-2 mx-2"
            }, null, 8, ["order", "isLogin", "isRegisteredWatchLater", "evaluation", "onCardClick", "onChangeWatchLater"]))
          }), 128))
        ]))
      }), 128)),
      _createTextVNode(),
      (_ctx.orderListAggregateDate.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "\n        あとで見るに追加されたお仕事はありません\n      "))
        : _createCommentVNode("", true),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_4, null, 512)
    ]),
    _createTextVNode(),
    _createVNode(_component_AppFooter),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}